<mat-toolbar class="editing-toolbar">
  <span>Editing: {{ currentUser?.login }}</span>

  <span class="spacer"></span>

  <!-- TODO: Allow deleting a section -->
  <button mat-raised-button class="tools-button" (click)="saveForm()" [disabled]="saveButtonDisabled">
    <mat-icon svgIcon="content-save"></mat-icon>&nbsp;
    <span>Save</span>
  </button>
</mat-toolbar>

<form [formGroup]="userForm" class="user-form">
  <mat-form-field>
    <mat-label>Login</mat-label>
    <input matInput formControlName="login" placeholder="Login" />
    <mat-error>{{ getErrorMessage(loginControl) }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Email</mat-label>
    <input matInput formControlName="email" placeholder="Email" />
    <mat-error>{{ getErrorMessage(emailControl) }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>First name</mat-label>
    <input matInput formControlName="firstname" placeholder="First name" />
  </mat-form-field>

  <mat-form-field>
    <mat-label>Surname</mat-label>
    <input matInput formControlName="surname" placeholder="Surname" />
  </mat-form-field>

  <mat-form-field *ngIf="userId == 'new'">
    <input matInput type="password" placeholder="Password" formControlName="password" required>
    <mat-error>{{ getErrorMessage(passwordControl) }}</mat-error>
  </mat-form-field>

  <mat-form-field *ngIf="userId == 'new'">
    <input matInput type="password" placeholder="Confirm Password" formControlName="password_confirm" required>
    <mat-error>{{ getErrorMessage(confirmPasswordControl) }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Covariate role</mat-label>
    <mat-select formControlName="covariate_role">
      <mat-option></mat-option>
      <mat-option *ngFor="let role of covariateRoles" [value]="role">
        {{ role | titlecase }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div class="slide-control">
    <mat-slide-toggle formControlName="disabled"></mat-slide-toggle>
    <mat-label class="slide-label">Active</mat-label>
  </div>

  <div class="slide-control" *ngIf="isAdmin">
    <mat-slide-toggle formControlName="isadmin"></mat-slide-toggle>
    <mat-label class="slide-label">Admin</mat-label>
  </div>
</form>
